import { IConfigImageCompositor } from "../../../../services/api/3d/CompositorImageApi/type";
import { ObjectService } from "../../../../services/ObjectService";
import { stateT } from "../../types";
import {
  ICameraProductStage,
  IProduct,
  ISelectItemObjectData,
  IStage,
} from "../uiTypes";
import {
  getProductByIdAndPath,
  getSelectObjectDataById,
  getCurrentCategoryFolder,
  getProductFromCache,
} from "./objectSelectors";

export const getPreviewImageById =
  (productId: string) =>
  (state: stateT): string | null => {
    const data = getSelectObjectDataById(productId)(state);
    if (!data) return null;

    console.log("data", data);

    return data.previewImage || null;
  };

export const getDataProductForGetImageById =
  (productId: string, selectData: ISelectItemObjectData) =>
  (state: stateT): IConfigImageCompositor => {
    const {
      pathObjectIds,
      geometryOptions,
      materialOptions,
      realId,
      projectId,
    } = selectData;

    // First try to get product from currentCategoryFolder (has fetched products)
    const currentCategoryFolder = getCurrentCategoryFolder(state);
    const projectInFolder = currentCategoryFolder?.projects?.find(
      p => p.id === projectId
    );
    const productFromFolder = projectInFolder?.availableProducts?.find(
      p => p.id === realId
    );

    // Try cache by project
    const productFromCache = getProductFromCache(projectId, realId)(state);

    // Fallback to path-based lookup
    const productFromPath = getProductByIdAndPath(
      realId,
      pathObjectIds,
      projectId
    )(state);

    const product = productFromFolder || productFromCache || productFromPath;

    if (!product) {
      throw new Error(`Product with id ${productId} not found`);
    }

    const stages = getStagesByProduct(product);
    const cameras = getCamerasByProduct(product);

    return {
      config: {
        stage: stages[0],
        camera: {
          ...cameras[0],
          "360steps": {
            total: cameras[0].rotationSteps,
            current: 1,
          },
        },
        products: [
          {
            id: product.id,
            name: product.name,
            projectId: product.projectId,
            paramString: product.paramString,
            resourceUrl: product.resource ?? null,
            options: [
              ...ObjectService.getOptionsByProductAndSelectData(
                "geometry",
                product,
                geometryOptions
              ),
              ...ObjectService.getOptionsByProductAndSelectData(
                "material",
                product,
                materialOptions
              ),
            ],
          },
        ],
      },
    };
  };

function getStagesByProduct(product: IProduct): IStage[] {
  const stages = product.availableStages || [];
  return stages.map(stage => ({
    id: stage.id,
    name: stage.name,
    paramString: stage.paramString,
    resourceUrl: stage.resource,
  }));
}

function getCamerasByProduct(product: IProduct): ICameraProductStage[] {
  const cameras = product.availableStages[0]?.cameras || [];
  return cameras;
}
